import { render, staticRenderFns } from "./ms-medical-history.vue?vue&type=template&id=420dd3b9&scoped=true"
import script from "./ms-medical-history.vue?vue&type=script&lang=js"
export * from "./ms-medical-history.vue?vue&type=script&lang=js"
import style0 from "./ms-medical-history.vue?vue&type=style&index=0&id=420dd3b9&prod&lang=scss&scoped=true"
import style1 from "./ms-medical-history.vue?vue&type=style&index=1&id=420dd3b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420dd3b9",
  null
  
)

export default component.exports